import Vue from "vue";
import VueI18n from "vue-i18n";
import enMessages from "./en_NZ.json";

Vue.use(VueI18n);

export default new VueI18n({
  locale: "en-NZ",
  messages: {
    "en-NZ": enMessages
  }
});



// WEBPACK FOOTER //
// ./src/locales/index.js